import React from "react";
import { Link } from "react-router-dom";

const SidebarItemWithCollapse = ({
    activeTab,
    activeSubTab,
    label,
    message,
    isCollapsed,
    mobile,
    setMobile,
    onClick,
    icon,
    subMenuItems,
    key,
}) => {
    return (
        <li className="nav-item">
            <Link
                className={`d-flex align-items-start list-item nav-link sidenav-items sidenav-items ${activeTab === message ? "active" : ""
                    }`}
            >
                {!isCollapsed && (
                    <>
                        <div className="db-icons db-icon-ai">{icon}</div>
                        <p className="d-block gap-1 approval-dropdown mb-0">
                            <div className="d-flex justify-content-between align-items-center">
                                <a
                                    className={
                                        "nav-link sidenav-items sidenav-items sidebar-approval list-item"
                                    }
                                    data-bs-toggle="collapse"
                                    href={`#collapse${key + message}`}
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls={`collapse${key + message}`}
                                >
                                    {label}
                                    <div className="dropdown-icon">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            className="ms-2 transition-transform duration-300"
                                            style={{ transformOrigin: "center" }}
                                        >
                                            <path
                                                fill="#A8A8A8"
                                                d="M5.293 6.293a1 1 0 0 1 1.414 0L8 7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414z"
                                            />
                                        </svg>
                                    </div>
                                </a>
                            </div>

                            <div className="collapse" id={`collapse${key + message}`}>
                                {subMenuItems?.map((subItem, index) => (
                                    <Link
                                        to={subItem?.path}
                                        onClick={() => onClick(subItem?.label)}
                                        key={subItem.label + index}
                                    >
                                        <div
                                            className={`card card-body submenu d-flex flex-row align-items-center ${activeSubTab === subItem?.label ? "active" : ""
                                                }`}
                                        >
                                            <span>{subItem?.label}</span>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </p>
                    </>
                )}

                {isCollapsed && (
                    <div className="sidebar-approval-collapse position-relative">
                        <div
                            className="db-icons gg"
                            onClick={() => {
                                setMobile((prev) => !prev);
                            }}
                        >
                            {icon}
                        </div>
                        {mobile && (
                            <div className="sidemenu-double-dropdown approval-dd-blk">
                                {subMenuItems?.map((subItem, index) => (
                                    <Link
                                        to={subItem?.path}
                                        onClick={() => onClick(subItem?.label)}
                                        key={subItem.label + index}
                                    >
                                        <div
                                            className={`card card-body submenu d-flex flex-row align-items-center ${activeSubTab === subItem?.label ? "active" : ""
                                                }`}
                                        >
                                            <span>{subItem?.label}</span>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </Link>
        </li>
    );
};

export default SidebarItemWithCollapse;
